import { Link } from "react-router-dom";
import { Phone, MessageSquareText } from "lucide-react";
import { PHONE_DISPLAY, TEL_HREF, SMS_HREF } from "@/data/site";

/**
 * Primary "Get a Free Estimate" + Call + Text button group.
 * `dark` styles the secondary buttons for dark backgrounds.
 */
export default function CtaGroup({ dark = false, className = "", estimateLabel = "Get a Free Estimate" }) {
  return (
    <div className={`flex flex-col sm:flex-row flex-wrap gap-3 ${className}`}>
      <Link to="/free-estimate" className="btn-primary" data-testid="cta-estimate">
        {estimateLabel}
      </Link>
      <a
        href={TEL_HREF}
        className={`btn-ghost ${dark ? "btn-on-dark" : ""}`}
        data-testid="cta-call"
      >
        <Phone size={16} strokeWidth={1.75} aria-hidden="true" />
        Call {PHONE_DISPLAY}
      </a>
      <a
        href={SMS_HREF}
        className={`btn-ghost ${dark ? "btn-on-dark" : ""}`}
        data-testid="cta-text"
      >
        <MessageSquareText size={16} strokeWidth={1.75} aria-hidden="true" />
        Text Us
      </a>
    </div>
  );
}
